import { initializeAmplifyAuth } from '@modules/authentication/utils';
import { replaceCodeAndErrorQueryParams } from '@modules/common/utils';
import { initializeSentry } from '@modules/sentry';
import { LicenseInfo } from '@mui/x-license-pro';
import App from 'App';
import { Amplify } from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { Userpilot } from 'userpilot';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import './index.scss';
import './polyfills';
import updatedAwsConfig from './updatedConfig';

// Fix for https://github.com/aws-amplify/amplify-js/issues/3494
replaceCodeAndErrorQueryParams();

Amplify.configure(updatedAwsConfig);

initializeAmplifyAuth();

initializeSentry();

Userpilot.initialize(process.env.REACT_APP_USERPILOT_APP_TOKEN);

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Toaster position="top-center" />
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
